import { FILTERS_SET_CONTROLS, FILTERS_SET_VALUES } from './types';

export const mutations = {
    [FILTERS_SET_CONTROLS]: (state, payload) => {
        state.data = payload;
    },
    [FILTERS_SET_VALUES]: (state, payload) => {
        if (!state.values[payload.id]) {
            state.values[payload.id] = {};
        }
        state.values[payload.id][payload.worldId] = payload.values;
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/mutations.js